export const TOAST_MESSAGE_LIMIT = 130;
